import Script from 'next/script';
import React from 'react';
import * as gtag from '../../../utils/gtag';
import { HubspotMeetingWrapper } from './styles';

export interface HubspotMeetingProps {
  slug: string;
  title?: string;
  description?: string;
  background?: 'primary' | 'white';
  gtagConversionEvent?: string;
}

const MEETINGS_SCRIPT_SRC = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js';

const HubspotMeeting: React.FC<HubspotMeetingProps> = ({
  slug,
  gtagConversionEvent,
  title,
  description,
  background = 'white',
}) => {
  React.useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (event.origin !== 'https://meetings.hubspot.com') return;
      if (event.data.meetingBookSucceeded && gtagConversionEvent) {
        gtag.event({ action: 'conversion', conversionEventId: gtagConversionEvent });
      }
    };
    window.addEventListener('message', onMessage);
    return () => window.removeEventListener('message', onMessage);
  }, [gtagConversionEvent]);

  // The script initializes automatically on first load. On subsequent navigations
  // (script already cached), onLoad won't fire — call refresh() manually after
  // a tick to ensure the container div is in the DOM.
  React.useEffect(() => {
    type HubSpotMeetingsWindow = { HubSpotMeetings?: { refresh: () => void } };
    const hs = (window as HubSpotMeetingsWindow).HubSpotMeetings;
    if (hs) hs.refresh();
  }, [slug]);

  return (
    <HubspotMeetingWrapper background={background as 'white' | 'primary'}>
      {title && <h1>{title}</h1>}
      {description && <p>{description}</p>}
      <Script type="text/javascript" src={MEETINGS_SCRIPT_SRC} strategy="afterInteractive" />
      <div>
        <div
          className="meetings-iframe-container"
          data-src={`https://meetings.hubspot.com/${slug}?embed=true`}
        ></div>
      </div>
    </HubspotMeetingWrapper>
  );
};

export default HubspotMeeting;
